<template>
  <div
    class="waggon-info-nav-button self-centered t-rounded"
    :style="`
    height: ${height?height:''};
    width: ${width?width:''};
    ${nohover?'opacity: 1;':''}
    `"
    >
    <v-icon>
      {{`keyboard_arrow_${direction}`}}
    </v-icon>
  </div>
</template>
<script>
export default {
  props: ['direction', 'height', 'width', 'nohover']
}
</script>
<style>
  .waggon-info-nav-button {
    display: flex;
    position: absolute;
    opacity: 0;
    background-color: rgba(0,0,0,0.2);
    transition: opacity 0.15s ease-in-out;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    animation: fadein 1.5s 0.6s;
  }
  .waggon-info-nav-button:hover {
    opacity: 1;
  }
  @keyframes fadein {
    from {
      opacity: 0;
    }
    45% {
      opacity: 1;
    }
    60% {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
</style>
